import React, { useState, useEffect } from 'react';
import { Row, Card, CardTitle, Label, FormGroup, Button, Form } from 'reactstrap';
import { NavLink, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import * as Yup from 'yup';
import { Field, useFormik } from 'formik';
import { NotificationContainer, NotificationManager } from 'react-notifications';

import { Colxx } from 'components/common/CustomBootstrap';
import IntlMessages from 'helpers/IntlMessages';
import { loginUser } from 'redux/actions';

import { callApi } from 'api handler/callApi';

const validatePassword = (value) => {
  let error;
  if (!value) {
    error = 'Please enter your password';
  } else if (value.length < 4) {
    error = 'Value must be longer than 3 characters';
  }
  return error;
};

const validateEmail = (value) => {
  let error;
  if (!value) {
    error = 'Please enter your email address';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address';
  }
  return error;
};

const Login = ({ loading, error, loginUserAction }) => {

  const history = useHistory();

  const validationSchema = Yup.object().shape({
    // email: Yup.string().email().required('Email is required'),
    password: Yup.string().min(6, 'Must be at least 6 chars!').required('Password is required'),
    phoneNumber: Yup
      .string().min(10, 'Must be at least 10 chars!')
      .min(10, 'Enter a 10 Digit number')
      .max(10, 'Enter a 10 Digit number')
      .required('Phone Number is required')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      ),
  });

  const initialValues = { phoneNumber: '', password: '' };

  const onSubmit = async (values) => {
    console.log("login called")
    const loginUser = {
      method: 'post',
      url: 'users/userLogin',
      data: {
        phoneNumber: values.phoneNumber,
        password: values.password
      }
    }
    console.log('login user => ', loginUser)

    if (!loading) {
      if (values.phoneNumber !== '' && values.password !== '') {

        try {

          const response = await callApi(loginUser);
          console.log(response)
          if (response && response.data.code === 200) {
            console.log("api success", response);
            // NotificationPrimary(response.message);
            await localStorage.setItem('data', JSON.stringify({ token: response.data.token, user: response.data.userId, userBasicDetails: response.data.userBasicDetails, role: response.data.role }));
            setTimeout(() => {

              history.push('/');
            }, 1000)


            NotificationManager.success(
              null,
              "Logged In successfully",
              3000,
              null,
              null,
              ''
            );

          }
          else {
            NotificationManager.error(
              null,
              "Wrong Mobile no or password",
              3000,
              null,
              null,
              ''
            );
          }

        } catch (error) {
          NotificationManager.error(
            null,
            "Something went wrong! Please try again.",
            3000,
            null,
            null,
            ''
          );
        }
      }
    }
    // console.log(response);
    // return response;
  };

  const formik = useFormik({ initialValues, validationSchema, onSubmit });
  const { handleSubmit, handleChange, values, touched, errors } = formik;

  // useEffect(() => {
  //   if (error) {
  //     NotificationManager.warning(error, 'Login Error', 3000, null, null, '');
  //   }
  // }, [error]);

  // const onUserLogin = (values) => {
  //   if (!loading) {
  //     if (values.email !== '' && values.password !== '') {
  //       loginUserAction(values, history);
  //     }
  //   }
  // };

  // const initialValues = { email, password };

  return (
    <Row className="h-100">
      <Colxx xxs="12" md="10" className="mx-auto my-auto">
        <Card className="auth-card">
          <div className="position-relative image-side ">
            <p className="text-white h2">OBCC Website Admin</p>
            <p className="white mb-0">
              Please use your credentials to login.
              <br />
              If you are not a member, please contact Teceads Solutions.
            </p>
          </div>
          <div className="form-side">
            <NavLink to="/" className="white">
              <img src="/assets/img/obcc-logo-black.png" width='100%' />
            </NavLink>
            <CardTitle className="mb-4">
              <IntlMessages id="user.login-title" />
            </CardTitle>

            <form className="av-tooltip tooltip-label-bottom" onSubmit={(e) => handleSubmit(e)}>
              <FormGroup className="form-group has-float-label">
                <Label>
                  <IntlMessages id="Phone Number" />
                </Label>
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  className="form-control"
                  value={values.phoneNumber}
                  onChange={handleChange}
                />

                {errors.phoneNumber && touched.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div>}

              </FormGroup>
              <FormGroup className="form-group has-float-label">
                <Label>
                  <IntlMessages id="user.password" />
                </Label>
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  onChange={handleChange}
                  value={values.password}
                  placeholder="Password"
                />

                {errors.password && touched.password && <div className="invalid-feedback d-block">{errors.password}</div>}

              </FormGroup>
              <div className="d-flex justify-content-between align-items-center">
                <NavLink to="/user/forgot-password">
                  <IntlMessages id="user.forgot-password-question" />
                </NavLink>
                <Button
                  color="primary"
                  className={`btn-shadow btn-multiple-state ${loading ? 'show-spinner' : ''
                    }`}
                  size="lg"
                >
                  <span className="spinner d-inline-block">
                    <span className="bounce1" />
                    <span className="bounce2" />
                    <span className="bounce3" />
                  </span>
                  <span className="label">
                    <IntlMessages id="user.login-button" />
                  </span>
                </Button>
              </div>
            </form>
          </div>
        </Card>
      </Colxx>
      <NotificationContainer />
    </Row>
  );
};
const mapStateToProps = ({ authUser }) => {
  const { loading, error } = authUser;
  return { loading, error };
};

export default connect(mapStateToProps, {
  loginUserAction: loginUser,
})(Login);
